import React, { useContext } from "react";

import { DataContext } from "../../../../../../providers/PelletsDataProvider";
import NewSelect from "../../../../../shared/forms/NewSelect";

const ProductSelect = ({
    localProduct,
    setLocalAmount,
    setLocalProduct,
    setShouldCalculate,
}) => {
    const dataContext = useContext(DataContext);
    const { zipcode } = dataContext.data;
    const { checkZipcodeLoose, checkZipcodePallet, setAmountError } =
        dataContext.actions;

    const productOptions = [
        { value: "loose", text: "Lose" },
        { value: "bags", text: "Sackware" },
        /*{ value: "big-bag", text: "Big-Bag" },*/
    ];

    const onChange = (event) => {
        const newProduct = event.target.value;

        if (newProduct === "loose") {
            setLocalAmount(4000);
        } else {
            if (localProduct === "loose") {
                setLocalAmount(1);
            }
        }
        setAmountError(false);
        setLocalProduct(newProduct);
        setShouldCalculate && setShouldCalculate(true);
        // Check also the zipcode again
        if (zipcode.length === 5) {
            if (newProduct === "loose") {
                checkZipcodeLoose(zipcode);
            } else {
                checkZipcodePallet(zipcode);
            }
        }
    };

    return (
        <NewSelect
            placeholder={"Produkt:"}
            name="product"
            options={productOptions}
            value={localProduct}
            onChange={onChange}
            fullwidth
            minWidth="120px"
        />
    );
};

export default ProductSelect;
